<!-- =========================================================================================
  File Name: cash.vue
  Description: Record Cash
========================================================================================== -->

<template>
  <div id="record-cash">

    <vx-card title="提现记录">
      <div slot="actions">
        <vx-input-group>
          <template slot="prepend">
            <flat-pickr v-model="startTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          </template>
          <template slot="prepend">
            <flat-pickr v-model="endTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          </template>
			<template slot="prepend">
			  <vs-select class="w-32" v-model="rangeVal">
				<vs-select-item :key="index" :value="item.val" :text="item.name" v-for="(item, index) in range" />
			  </vs-select>
			</template>
          <vs-input class="w-32" v-model="uid" placeholder="UID" />
          <template slot="append">
            <vs-input class="w-32" v-model="username" placeholder="用户名" />
          </template>
          <template slot="append">
            <vs-input class="w-32" v-model="ip" placeholder="IP" />
          </template>
          <template slot="append">
            <vs-select class="w-32" v-model="statusVal">
              <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in statusList" />
            </vs-select>
          </template>
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>
      <vs-table stripe :data="list" noDataText="暂无提现记录">
        <template slot="thead">
          <vs-th width="100">UID</vs-th>
          <vs-th>用户名</vs-th>
          <vs-th>姓名</vs-th>
		  <vs-th>上级代理</vs-th>
          <vs-th>银行名称</vs-th>
          <vs-th>钱包地址</vs-th>
          <vs-th>USDT金额</vs-th>
          <vs-th>应付金额</vs-th>
          <vs-th>手续费</vs-th>
		  <vs-th>账后余额</vs-th>
          <vs-th>状态</vs-th>
          <vs-th>时间</vs-th>
          <vs-th>IP</vs-th>
          <vs-th>备注</vs-th>
          <vs-th>操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list">
            <vs-td :data="item.uid">{{item.uid}}</vs-td>
            <vs-td :data="item.username">{{item.username}}</vs-td>
            <vs-td :data="item.name">{{item.name}}</vs-td>
			<vs-td :data="item.parentList">
			  <span v-if="!item.parentList || item.parentList.length === 0">无</span>
			  <span v-else>
			    <span v-for="(item2, index2) in item.parentList" :key="index2">
			      <router-link :to="{ name: 'userList', query: { parent: item2 } }">
			        {{item2}}
			      </router-link> >
			    </span>
			   <!-- <span>{{item.username}}</span> -->
			  </span>
			</vs-td>
            <vs-td :data="item.bank">{{item.bank}}</vs-td>
            <vs-td :data="item.code">{{item.code}}</vs-td>
             <vs-td :data="item.code">{{item.usdt}}</vs-td>
            <vs-td :data="item.pay"><b>{{virtualRate[item.bank] ? parseFloat(item.pay / virtualRate[item.bank]).toFixed(4) : item.pay}}</b>{{item.icon === '元' ? item.bank : '元'}}</vs-td>
            <vs-td :data="item.fee"><b>{{virtualRate[item.bank] ? parseFloat(item.fee / virtualRate[item.bank]).toFixed(4) : item.fee}}</b>{{item.icon === '元' ? item.bank : '元'}}</vs-td>
			<vs-td :data="item.balance">{{item.balance}}</vs-td>
            <vs-td :data="item.status" :class="{ 'text-success': item.status == 1, 'text-danger': item.status == 2, 'font-bold': item.status == 1 || item.status == 2 }">{{statusList[parseInt(item.status) + 1]}}</vs-td>
            <vs-td :data="item.date">{{item.date}}</vs-td>
            <vs-td :data="item.ip">{{item.ip}}</vs-td>
            <vs-td :data="item.remark">{{item.remark === '' ? '无' : item.remark}}</vs-td>
            <vs-td>
			  <vs-button color="success" type="filled" size="small" @click="toRecord" :data-index="index">账变</vs-button>
              <vs-button color="success" type="filled" size="small" @click="pass" :data-index="index" data-status="1" class="mr-2" v-if="item.status == 0">通过</vs-button>
              <vs-button color="warning" type="filled" size="small" @click="showRefuseReason" :data-index="index" class="mr-2" v-if="item.status == 0">拒绝</vs-button>
              <!-- <vs-button color="danger" type="filled" size="small" @click="del" :data-index="index">删除</vs-button> -->
            </vs-td>
          </vs-tr>
          <vs-tr >
            <vs-td class="font-bold">合计</vs-td>
            <vs-td>-</vs-td>
            <vs-td>-</vs-td>
            <vs-td>-</vs-td>
            <vs-td>-</vs-td>
			<vs-td>-</vs-td>
            <vs-td :class="{ 'font-bold': total[0] > 0 }">{{total[0].toFixed(4)}}</vs-td>
            <vs-td :class="{ 'font-bold': total[1] > 0 }">{{total[1].toFixed(4)}}</vs-td>
            <vs-td>-</vs-td>
            <vs-td>-</vs-td>
            <vs-td>-</vs-td>
            <vs-td>-</vs-td>
            <vs-td>-</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>

    <vs-prompt
      vs-title="填写拒绝理由"
      vs-accept-text="确认拒绝"
      vs-cancel-text="取消"
      :vs-active.sync="refuseReasonShow"
      @vs-accept="refuse"
    >
      <vs-input class="w-full" v-model="refuseReason" label-placeholder="请填写拒绝理由" />
    </vs-prompt>
  </div>
</template>

<script>

import { Mandarin as flatPickrZh } from 'flatpickr/dist/l10n/zh.js'

export default {
  data() {
    return {
      page: 1,
      totalPage: 1,
      list: [],
      startTime: '',
      endTime: '',
      shortname: '',
      uid: '',
      username: '',
      ip: '',
      statusList: ['提现状态'],
      statusVal: 0,
      total: [0, 0],
      flatPickrConfig: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        locale: flatPickrZh
      },
      refuseReasonShow: false,
      refuseIndex: 0,
      refuseReason: '',
      virtualRate: 1,
	  range: [{ val: '', name: '范围' }, { val: 'self', name: '自身' }, { val: 'team', name: '团队' }],
	  rangeVal: '',
    }
  },
  watch: {
    page(newValue) {
      this.page = newValue
      this.load()
    }
  },
  methods: {
    pass (e) {
      const dataset = e.currentTarget.dataset
      const postdata = {}
      postdata.id = this.list[dataset.index].id
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认通过吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('money-cashPass', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.load()
          })
        }
      })
    },
    refuse () {
      const postdata = {}
      postdata.id = this.list[this.refuseIndex].id
      postdata.reason = this.refuseReason
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认拒绝吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('money-cashRefuse', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.load()
          })
        }
      })
    },
    showRefuseReason(e) {
      this.refuseIndex = e.currentTarget.dataset.index
      this.refuseReasonShow = true
    },
    load () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.page = this.page
      postdata.start = this.startTime
      postdata.end = this.endTime
      postdata.uid = this.uid
      postdata.username = this.username
      postdata.status = this.statusVal
	  postdata.range = this.rangeVal
      this.$utils.post('record-cash', postdata).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
        this.total = [0, 0]
        for (let i = 0; i < res.list.length; i++) {
          if (res.list[i].status != 1) continue
          this.total[0] += parseFloat(res.list[i].pay)
          this.total[1] += parseFloat(res.list[i].fee)
        }
      })
    },
    del(e) {
      const index = e.currentTarget.dataset.index
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该订单吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          const postdata = {}
          postdata.authKey = localStorage.getItem('authKey')
          postdata.id = this.list[index].id
          this.$utils.post('money-cashDelete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.load()
          })
        }
      })
    },
		toRecord (e) {
		  const index = e.currentTarget.dataset.index
		  const uid = this.list[index].uid
		  this.$router.push({ name: 'recordUser', query: { uid: uid } })
		},
    search() {
      this.page = 1
      this.load()
    }
  },
  mounted () {
    // 初始化时间
    const myDate = new Date()
    this.endTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)
    myDate.setTime(myDate.getTime() - 86400000 * 0)
    this.startTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)

    // 状态
    this.$utils.post('money-cashStatusList', { authKey: localStorage.getItem('authKey') }).then(res => {
      for (let i = 0; i < res.length; i++) {
        this.statusList.push(res[i])
      }
    })

    // 更新提醒
    this.$utils.post('notification-updateRemind', { authKey: localStorage.getItem('authKey'), type: 'cash' })

    // 虚拟汇率
    this.$utils.post('setting-virtualList', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.virtualRate = {}
      res.forEach(item => {
        this.virtualRate[item.name] = item.rate
      })
    })

    this.load()
  }
}
</script>
